import { Link } from 'react-router-dom';

export default function GetInvolvedHero() {
  return (
    <section className="relative pt-40 pb-24 overflow-hidden bg-[#1A0A1E]">
      <div className="absolute top-0 left-0 w-full h-1 bg-gradient-to-r from-[#4B0082] via-[#C084FC] to-[#7B2D8B]"></div>
      <div className="absolute top-20 right-0 w-[600px] h-[600px] rounded-full bg-[#7B2D8B]/15 blur-3xl pointer-events-none"></div>
      <div className="absolute bottom-0 left-0 w-[400px] h-[400px] rounded-full bg-[#4B0082]/10 blur-3xl pointer-events-none"></div>

      <div className="max-w-7xl mx-auto px-6 md:px-10 relative z-10">
        <div className="inline-flex items-center gap-2 px-4 py-2 rounded-full border border-purple-400/30 bg-purple-900/30 backdrop-blur-sm mb-8">
          <span className="w-2 h-2 rounded-full bg-[#C084FC] animate-pulse"></span>
          <span className="text-purple-200 text-sm tracking-wide">Join the Movement</span>
        </div>

        <h1 className="text-5xl md:text-7xl font-extrabold text-white leading-tight mb-6 max-w-3xl">
          Be Part of the <span className="text-[#C084FC]">Change</span>
        </h1>

        <p className="text-gray-400 text-lg md:text-xl max-w-2xl leading-relaxed mb-12">
          Every contribution — big or small — helps us reach more people living with epilepsy across Nigeria and Africa. There are many ways you can support IKIRU's mission.
        </p>

        <div className="flex flex-col sm:flex-row gap-4">
          <a
            href="#donate"
            className="px-8 py-4 rounded-full bg-[#7B2D8B] text-white font-semibold text-base hover:bg-[#6a2578] transition-all cursor-pointer whitespace-nowrap text-center"
          >
            Donate Now
          </a>
          <a
            href="#get-involved-form"
            className="px-8 py-4 rounded-full border-2 border-purple-300/50 text-white font-semibold text-base hover:bg-white/10 transition-all cursor-pointer whitespace-nowrap text-center flex items-center justify-center gap-2"
          >
            Volunteer or Partner <i className="ri-arrow-right-line"></i>
          </a>
        </div>

        {/* Quick stats */}
        <div className="mt-20 grid grid-cols-2 md:grid-cols-4 gap-5">
          {[
            { icon: 'ri-heart-fill', value: '500+', label: 'Patients Supported' },
            { icon: 'ri-group-fill', value: '1,200+', label: 'Volunteers Engaged' },
            { icon: 'ri-building-fill', value: '30+', label: 'Partner Organizations' },
            { icon: 'ri-map-pin-fill', value: '10', label: 'Community Groups' },
          ].map((s) => (
            <div key={s.label} className="bg-purple-900/25 backdrop-blur-sm rounded-2xl p-5 border border-purple-400/20 flex flex-col gap-2">
              <div className="w-9 h-9 flex items-center justify-center rounded-xl bg-[#7B2D8B]/40">
                <i className={`${s.icon} text-[#C084FC] text-lg`}></i>
              </div>
              <div className="text-3xl font-extrabold text-[#C084FC]">{s.value}</div>
              <div className="text-white/60 text-sm leading-snug">{s.label}</div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
